import { Box, Button, Card, CardBody, CardHeader, CheckBox, Form, FormField, Heading, Image, Markdown, Paragraph, RangeInput, Text, TextInput } from "grommet"
import { useTranslation } from "react-i18next";
import { useGetOverlaySettingsQuery, useUpdateOverlaySettingsMutation } from "../api/userApi";
import { useEffect, useState } from "react";
import { Checkmark, Copy, Info } from "grommet-icons";
import { useDispatch } from "react-redux";
import { addNotification } from "../slices/notificationsSlice";
import { InfoSection } from "../components/layout/InfoSection";
import { OverlaySettingsTipsTranslation } from "../md-translation/OverlaySettingsTipsTranslation";
import { FadedAccordion } from "../components/layout/FadedAccordion";
import { TextInputWithButton } from "../forms/TextInputWithButton";

export const OverlaySettingsPage = () => {

    const { t, ready, i18n } = useTranslation('settings', {
        useSuspense: false,
    });

    const dispatch = useDispatch();

    const { data: overlaySettings } = useGetOverlaySettingsQuery();
    const [updateOverlaySettings] = useUpdateOverlaySettingsMutation();

    const [volume, setVolume] = useState();
    const [overlayLink, setOverlayLink] = useState();
    const [overlayLinkCopied, setOverlayCopied] = useState(false);

    useEffect(() => {
        setVolume(overlaySettings?.volume)
    }, [overlaySettings])

    const handleVolume = (event) => {
        updateOverlaySettings({ volume: event.target.value }).then((response) => dispatch(addNotification({ show: true, message: 'Volume successfully saved.', status: 'normal' })))
    }

    const handleOverlayEnable = (event) => {
        const value = event.target.checked;
        updateOverlaySettings({ enabled: value }).then((response) => dispatch(addNotification({ show: true, message: `Overlay successfully ${value ? 'enabled' : 'disabled'}.`, status: 'normal' })))
    }

    const handleOverlayLinkCopy = () => {
        navigator.clipboard.writeText(overlayLink)
        setOverlayCopied(true);
        dispatch(addNotification({ show: true, message: 'Overlay link successfully copied.', status: 'normal' }))
        setTimeout(() => {
            setOverlayCopied(false);
        }, 1000)
    }
    
    useEffect(() => {
        setOverlayLink(`${process.env.REACT_APP_FE_URL}/overlays/${overlaySettings?.widgetToken}`);
    }, [overlaySettings])

    return (
        <Card /*height={'100vh'}*/>
            <CardHeader pad={{ top: 'medium', left: 'medium', right: 'medium' }}>
                <Heading level={3} margin={'none'}>{t('overlaySettingsTitle')}</Heading>
            </CardHeader>
            <CardBody direction="row-responsive" gap="medium" responsive>
                <Box margin={{ top: 'small', bottom: 'small' }} basis="50%">
                    <Form>
                        <Box gap="small">
                            <CheckBox toggle label={t('enableOverlay')} checked={overlaySettings?.enabled} pad={'none'} onChange={handleOverlayEnable} />
                            <FormField label={t('overlayLink')} noBorder>
                                <TextInputWithButton type="password" value={overlayLink} readOnly>
                                    <Button style={{ borderTopRightRadius: '6px', borderBottomRightRadius: '6px', borderTopLeftRadius: '0', borderBottomLeftRadius: '0' }} icon={overlayLinkCopied ? <Checkmark /> : <Copy />} onClick={handleOverlayLinkCopy} />
                                </TextInputWithButton>
                                {/* <Box direction="row" border round="xsmall">
                                    <TextInput type="password" plain value={overlayLink} readOnly />
                                    <Button style={{ borderTopRightRadius: '6px', borderBottomRightRadius: '6px', borderTopLeftRadius: '0', borderBottomLeftRadius: '0' }} icon={overlayLinkCopied ? <Checkmark /> : <Copy />} onClick={handleOverlayLinkCopy} />
                                </Box> */}
                            </FormField>
                            <FormField label={t('volume')} noBorder noFocus>
                                <RangeInput value={volume} onChange={(event) => setVolume(event.target.value)} min={0} max={1} step={0.01} onMouseUp={handleVolume} onTouchEnd={handleVolume} />
                            </FormField>
                        </Box>
                    </Form>
                </Box>
                <Box basis="50%">
                    <FadedAccordion previewHeight={600}>
                        <InfoSection>
                            <Box>
                                <Markdown components={{ img: { props: { style: { width: '100%' } } } }}>{`${OverlaySettingsTipsTranslation[i18n.language]}`}</Markdown>
                            </Box>
                        </InfoSection>
                    </FadedAccordion>
                </Box>
            </CardBody>
        </Card>
    )
}